<div [class]="field.styleValue">
  <span class="text-value">
    <a [target]="target" href="{{identifier?.href}}">{{ identifier?.text }}</a>
  </span>
</div>